import React from 'react';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { TransformCta } from '../TransformCta';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="bg-panel py-16 sm:py-24" aria-labelledby="testimonials-title" data-id="element-346" data-mp="3mepnd1ioybv5">
      <div className="mx-auto max-w-6xl px-5" data-id="element-347" data-mp="3r8tv3mzs6nxa">
        <SectionHeading kicker="What HVAC professionals are saying" title={<span id="testimonials-title" data-id="element-349" data-mp="42jcdmkzqiia">Technicians already using the pathway</span>} data-id="element-348" data-mp="1r1yq0du7kf" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-350" data-mp="925o1rl67qoz">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl border border-line bg-ink p-6 sm:p-7" data-id="element-351" data-mp="e0z5tw7hq3uy">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-352" data-mp="2atsiy486o5qq">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-amber text-amber" aria-hidden="true" data-id="element-353" data-mp="2ft57quim7mvy" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[17px] leading-relaxed text-white" data-id="element-354" data-mp="1smdrdx4gt3s7">“{t.quote}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-4 border-t border-line pt-5" data-id="element-355" data-mp="1iupuhgp52ujc">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-volt" data-id="element-356" data-mp="1et4li6fq70ef" />
                <div className="min-w-0" data-id="element-357" data-mp="26kaocumtzc7e">
                  <p className="flex items-center gap-1.5 font-display text-xl font-bold uppercase text-white" data-id="element-358" data-mp="26ldfn3o2fgnu">
                    {t.name}
                    <BadgeCheckIcon className="h-5 w-5 shrink-0 text-volt" aria-label="Verified buyer" data-id="element-359" data-mp="22ktgjujxm2z2" />
                  </p>
                  <p className="text-sm text-mist" data-id="element-360" data-mp="r3a9fr38dfv8">
                    {t.role} · {t.location}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <TransformCta label="Join these technicians today" data-id="element-361" data-mp="nl4fwkcrvd7e" />
      </div>
    </section>;
}